import { Link } from 'react-router-dom';
import { QUIZ_BRAND } from '../../constants/competition';

export function BrandMark({ inverse = false }: { inverse?: boolean }) {
  return (
    <Link className="brand-mark group" to="/" aria-label={`${QUIZ_BRAND.name} home`}>
      <span className="brand-logo-plate" aria-hidden="true">
        <img className="brand-logo-image" src="/brand/unesco-cregu-india.png" alt="" />
      </span>
      <span className="brand-mark-copy leading-tight">
        <span className={`brand-organization-name ${inverse ? 'text-white' : 'text-navy'}`}>
          {QUIZ_BRAND.name}
        </span>
        <span className={`brand-organization-subtitle ${inverse ? 'text-blue-200' : 'text-slate-500'}`}>
          {QUIZ_BRAND.subtitle}
        </span>
        <span className={`brand-competition-name ${inverse ? 'text-blue-100' : 'text-royal'}`}>{QUIZ_BRAND.title}</span>
      </span>
    </Link>
  );
}
